import operatorApiService from "../../../services/operator-api.service";
import { FourvehicleLayoutData } from "../../../types/fourvehicle";

const startLayoutCheckFourvehicle = (
  layoutData: FourvehicleLayoutData | null,
  monitorConsoleId: number
) => {
  const checkVehicleLayout = async () => {
    if (!layoutData?.layoutInfo?.length) return;

    try {
      const response = await operatorApiService.doGetFourvehicleLayoutCheck({
        monitorConsoleId,
      });

      const resultCodes = (response?.layoutInfo || [])
        .slice()
        .sort((a: any, b: any) => a.layout_id - b.layout_id)
        .map((v: any) => v.vehicle_communication_code);

      const originalCodes = layoutData.layoutInfo
        .slice()
        .sort((a, b) => a.layout_id - b.layout_id)
        .map((v) => v.vehicle_communication_code);

      const isMismatch =
        resultCodes.length !== originalCodes.length ||
        resultCodes.some(
          (code: string, i: number) => code !== originalCodes[i]
        );

      if (isMismatch) {
        window.location.reload();
      }
    } catch (e) {
      console.error("4車両レイアウト確認エラー:", e);
    }
  };

  checkVehicleLayout();
};

export default startLayoutCheckFourvehicle;
